import React, { Suspense } from 'react'
import { Router } from 'react-router'
import globalhistory from '../../router/globalhistory'
import hasuraClient from '../../apollo/apollo-client'
import LinearProgress from '@material-ui/core/LinearProgress'
import { Switch, Route, Redirect } from 'react-router-dom'
import { routes } from '../../router/router'
import { RouteState, RouteGuard } from '../../typings/router.def'
import NotificationContainer from '../../components/layout/NotificationContainer'
import NoMatch from './NoMatch'
import NotificationProvider from '../../components/layout/NotificationProvider'
import { useAuthContext } from '../../components/layout/context/AuthContext'
import { ApolloProvider } from '@apollo/client'
import { Enum_User_Role_Enum } from '../../typings/generated/schema'

const roles = Enum_User_Role_Enum
const canVisitRoute = (routeGuard?: RouteGuard, currentRole?: string) => {
  if (routeGuard === RouteGuard.Anonymous) {
    return true
  }
  return !!(currentRole && currentRole === roles.Client)
}

const AppCore = () => {
  const { authUser } = useAuthContext()
  const currentRole = authUser?.role

  return (
    <NotificationProvider>
      <ApolloProvider client={hasuraClient}>
        <Router history={globalhistory}>
          <Suspense fallback={<LinearProgress variant={'query'} />}>
            <Switch>
              {routes.map((route) => {
                const can = canVisitRoute(route.guard, currentRole)
                return (
                  <Route exact path={route.path} key={`route_${route.name}`}>
                    {can ? (
                      React.createElement(route.component)
                    ) : (
                      <Redirect
                        exact
                        to={RouteState.Logout}
                        key={`redirect_${route.name}`}
                      />
                    )}
                  </Route>
                )
              })}
              <Route>
                <NoMatch />
              </Route>
            </Switch>
          </Suspense>
        </Router>
        <NotificationContainer />
      </ApolloProvider>
    </NotificationProvider>
  )
}
export default AppCore
